import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Spinner } from "react-bootstrap";
import logoMain from "../../assets/icons/logo_main.svg"
import FormInput from "../../components/FormInput";
import { endpoints } from "../../helpers/Endpoints";
import { api } from "../../helpers/apiCore";
import { usePasswordResetContext } from "../../contexts/PasswordResetContex";
import errorInfoIcon from "../../assets/icons/error_info.svg";
import '../../styles/auth.css';

const ChangePassword = () => {

	const { setEmail } = usePasswordResetContext();

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertVariant, setAlertVariant] = useState<"danger" | "success">("danger");
	const [error, setError] = useState<string | null>(null);
	const [formData, setFormData] = useState({
		email: "",
	});

	const navigate = useNavigate();

	const sendOtp = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsSubmitting(true);
		setShowAlert(false);
		setError(null);
		setAlertMessage(null);
		try {
			const response = await api.create(endpoints.forgotPassword, formData);
			const responseData = response.data;
			const successMessage = responseData?.message || responseData?.data?.message || 'OTP sent successfully';
			setAlertMessage(successMessage);
			setAlertVariant("success");
			setShowAlert(true);
			setEmail(formData.email);
			navigate('/auth/otp-verification');
		} catch (error: any) {
			console.log(error);
			const message = error?.response?.data?.message || 'Unable to send OTP, please try again';
			setError(message);
			setShowAlert(true);
			setAlertVariant("danger");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<>
			<div className="body-bg-blue">
				<div className="auth-body">
					<div className="auth-img-white mb-5">
						<img src={logoMain} alt="logo" />
						<h2>Scholarswitch</h2>
					</div>
					<Card>
						<Card.Body>
							<h3>Change Password</h3>
							<p>Enter your email to reset your password</p>
							<div>
								<form onSubmit={sendOtp}>
									<div className="mt-5 mb-3 text-left">
										<FormInput
											label="Email Address"
											type="email"
											name="email"
											placeholder="email"
											value={formData.email}
											onChange={(e) => {
												setFormData({ ...formData, email: e.target.value });
												if (error) setError(null)
											}}
										/>
									</div>

									{showAlert && (
										<Alert
											variant={alertVariant}
											className="alert-error"
										>
											{error && <img src={errorInfoIcon} alt="error" />}
											{alertVariant === "danger" ? error : alertMessage}
										</Alert>
									)}

									<Button type="submit" disabled={isSubmitting || !formData.email}>
										{isSubmitting ? <Spinner animation="border" size="sm" /> : "Send Reset Code"}
									</Button>
								</form>
							</div>
							<Link to={'/'}>Back to login</Link>
						</Card.Body>
					</Card>
				</div>
			</div>
		</>
	)
};

export default ChangePassword;